import { Separator } from '@chakra-ui/react';
import { forwardRef } from 'react';

import { DividerDefaultProps, type DividerProps } from './Divider.types';

const Divider = forwardRef<HTMLDivElement, DividerProps>(({ ...props }, ref) => {
  return <Separator ref={ref} width="100%" {...props} />;
});

Divider.displayName = 'Divider';
Divider.defaultProps = DividerDefaultProps;

export { Divider };
